import { FC, useState, useEffect } from "react";
import {
	Box,
	Button,
	Divider,
	FormLabel,
	Switch,
	TextField,
	Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import {
	getEmailNotificationFrequency,
	setEmailNotificationFrequency,
	updateUser,
} from "../actions/form";
import { ESRState } from "../types/data";

export const SettingsPage: FC = () => {
	const dispatch = useDispatch();
	const user = useSelector((state: ESRState) => state.current_user);

	const isEmailNotificationDailyReport = useSelector(
		(state: ESRState) => state.email_notification_daily_report,
	);
	const isEmailNotificationWeeklyReport = useSelector(
		(state: ESRState) => state.email_notification_weekly_report,
	);

	const [email, setEmail] = useState(user?.email ?? "");
	const [firstName, setFirstName] = useState(user?.first_name ?? "");
	const [lastName, setLastName] = useState(user?.last_name ?? "");
	const [password, setPassword] = useState("");

	const [emailUpdated, setEmailUpdated] = useState(false);
	const [nameUpdated, setNameUpdated] = useState(false);
	const [passwordUpdated, setPasswordUpdated] = useState(false);

	const handleSendDailyChange = () => {
		dispatch(
			setEmailNotificationFrequency(
				email,
				!isEmailNotificationDailyReport,
				isEmailNotificationWeeklyReport,
			),
		);
	};

	const handleSendWeeklyChange = () => {
		dispatch(
			setEmailNotificationFrequency(
				email,
				isEmailNotificationDailyReport,
				!isEmailNotificationWeeklyReport,
			),
		);
	};

	useEffect(() => {
		if (user) {
			dispatch(getEmailNotificationFrequency(email));
		}
	}, []);

	return (
		<>
			<Box sx={{ px: "300px", py: "60px" }}>
				<Typography fontSize={24} fontWeight={700}>
					Account Settings - TREC
				</Typography>

				<Divider sx={{ my: "40px" }} />

				<Typography mt="40px" fontSize={16} fontWeight={700}>
					My Information
				</Typography>
				{/*<Typography mt="16px" fontSize={12} fontWeight={400} color="#00000099">*/}
				{/*  Account Email*/}
				{/*</Typography>*/}
				{/*<Grid mt="16px" container columnSpacing="16px" alignItems="center">*/}
				{/*  <Grid item xs={6}>*/}
				{/*    <TextField*/}
				{/*      disabled*/}
				{/*      label="Enter New Email"*/}
				{/*      size="small"*/}
				{/*      fullWidth*/}
				{/*      value={email}*/}
				{/*      onChange={(e) => setEmail(e.target.value)}*/}
				{/*    />*/}
				{/*  </Grid>*/}
				{/*  <Grid item xs={6}>*/}
				{/*    <Button*/}
				{/*      disabled*/}
				{/*      variant="contained"*/}
				{/*      size="small"*/}
				{/*      color={emailUpdated ? "success" : "inherit"}*/}
				{/*      onClick={() =>*/}
				{/*        dispatch(*/}
				{/*          updateUser({ email }, () => {*/}
				{/*            setEmailUpdated(true);*/}
				{/*          }),*/}
				{/*        )*/}
				{/*      }*/}
				{/*    >*/}
				{/*      {emailUpdated ? "Success!" : "Update"}*/}
				{/*    </Button>*/}
				{/*  </Grid>*/}
				{/*</Grid>*/}
				<Typography mt="40px" fontSize={12} fontWeight={400} color="#00000099">
					Name
				</Typography>
				<Grid mt="16px" container columnSpacing="16px" alignItems="center">
					<Grid item xs={3}>
						<TextField
							label="First Name"
							size="small"
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
						/>
					</Grid>
					<Grid item xs={3}>
						<TextField
							label="Last Name"
							size="small"
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<Button
							variant="contained"
							size="small"
							color={nameUpdated ? "success" : "inherit"}
							onClick={() =>
								dispatch(
									updateUser(
										{
											first_name: firstName,
											last_name: lastName,
										},
										() => {
											setNameUpdated(true);
										},
									),
								)
							}
						>
							{nameUpdated ? "Success!" : "Update"}
						</Button>
					</Grid>
				</Grid>
				<Typography mt="40px" fontSize={12} fontWeight={400} color="#00000099">
					Change Password
				</Typography>
				<Grid
					mt="16px"
					container
					rowSpacing="8px"
					columnSpacing="16px"
					alignItems="center"
				>
					<Grid item xs={6}>
						<TextField
							label="Enter New Password"
							size="small"
							fullWidth
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<Button
							variant="contained"
							size="small"
							color={passwordUpdated ? "success" : "inherit"}
							onClick={() =>
								dispatch(
									updateUser({ password }, () => {
										setPasswordUpdated(true);
									}),
								)
							}
						>
							{passwordUpdated ? "Success!" : "Update"}
						</Button>
					</Grid>
				</Grid>

				<Divider sx={{ my: "40px" }} />

				<Typography mt="40px" fontSize={16} fontWeight={700}>
					Email Notification Management
				</Typography>

				<Grid
					container
					alignItems="center"
					columnSpacing="16px"
					sx={{
						height: 56,
					}}
				>
					<Grid item xs={3}></Grid>
					<Grid item xs={3}>
						<FormLabel htmlFor="weekly-report">
							<Typography mt="16px" fontSize={14} fontWeight={500}>
								Daily Report
							</Typography>
						</FormLabel>
					</Grid>
					<Grid item xs={3}>
						<FormLabel htmlFor="weekly-todo">
							<Typography mt="16px" fontSize={14} fontWeight={500}>
								Weekly Report
							</Typography>
						</FormLabel>
					</Grid>
				</Grid>
				<Divider />
				<Grid
					container
					alignItems="center"
					sx={{ height: 100, background: "#003E6205" }}
				>
					<Grid item xs={3} p="16px">
						<Typography fontSize={12} fontWeight={400} color="#00000099">
							Account Email
						</Typography>
						<Typography mt="12px" fontSize={16} fontWeight={500}>
							{user?.email ?? ""}
						</Typography>
					</Grid>
					<Grid item xs={3} p="16px">
						<Switch
							checked={isEmailNotificationDailyReport}
							onChange={handleSendDailyChange}
							id="daily-report"
						/>
					</Grid>
					<Grid item xs={3} p="16px">
						<Switch
							checked={isEmailNotificationWeeklyReport}
							onChange={handleSendWeeklyChange}
							id="weekly-report"
						/>
					</Grid>
				</Grid>
				<Divider />
				<Button sx={{ mt: "20px" }} variant="text">
					+ Secondary Email
				</Button>
			</Box>
		</>
	);
};
